import { get } from 'lodash';
import { mapGetters, mapState } from 'vuex';
import env from '@/env';

export default {
  props: {
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('market', ['chartTimeline', 'chartType', 'market']),
    showDownload() {
      return get(this.chartOptions, 'includeDownload', true);
    },
  },
  methods: {
    onDownload() {
      const url = `${env.CHART_CSV_DOWNLOAD_URL}?marketid=${this.market.marketId}&timespan=${this.chartTimeline}`;
      window.open(url, '_blank');
    },
  },
};
